import { ApiError } from "./api";

const FRIENDLY_MESSAGES: Record<string, string> = {
  RATE_LIMITED: "Too many requests. Please slow down and try again in a moment.",
  INSUFFICIENT_CREDITS: "You've used all generations on your plan this month. Upgrade or wait for the next reset.",
  MODEL_REQUIRES_UPGRADE: "This model requires a higher subscription tier.",
  INVALID_CREDENTIALS: "Wrong email or password.",
  EMAIL_TAKEN: "This email is already registered. Try signing in instead.",
  INVALID_INPUT: "Please check the form and try again.",
  UNAUTHENTICATED: "Please sign in to continue.",
  SESSION_EXPIRED: "Your session expired. Please sign in again.",
  NOT_FOUND: "We couldn't find what you were looking for.",
  REQUEST_FAILED: "The request failed. Please try again.",
  EMAIL_SEND_FAILED: "Couldn't send the email. Please try again later.",
  SIGNUP_FAILED: "Couldn't create your account. Please try again.",
  INTERNAL_ERROR: "Something went wrong on our end. Please try again.",
  STRIPE_NOT_CONFIGURED: "Billing is not configured yet. Contact support.",
  CHECKOUT_FAILED: "Couldn't start checkout. Please try again.",
  PORTAL_FAILED: "Couldn't open the billing portal. Please try again.",
  TRAIN_FAILED: "Voice training failed. Try retraining.",
  GEN_FAILED: "Generation failed. Your credit will be refunded.",
  VOICE_NOT_READY: "This voice profile is still training.",
  INVALID_URL: "That URL doesn't look right.",
  INVALID_PROTOCOL: "Only http and https URLs are supported.",
  BLOCKED_HOST: "Private or local URLs aren't allowed.",
  NO_CONTENT_FOUND: "Couldn't extract enough content from that page.",
  FETCH_FAILED: "Couldn't fetch that URL. The site may be down or blocking us.",
  TIMEOUT: "Request took too long — the server didn't respond in time. Please try again.",
  NETWORK_ERROR: "Couldn't reach the server. Check your internet connection and try again.",
  RESPONSE_TOO_LARGE: "That page is too large. Try a single article instead.",
  IMPORT_FAILED: "URL import failed. Please try a different page.",
  TWITTER_AUTH_FAILED: "X authentication failed. Verify all 4 keys and that the app has Read+Write permission.",
  BLUESKY_AUTH_FAILED: "Bluesky authentication failed. Use an App Password (not your main login password).",
  LINKEDIN_AUTH_FAILED: "LinkedIn authentication failed. Try reconnecting.",
  LINKEDIN_TOKEN_EXPIRED: "LinkedIn access expired. Reconnect the account.",
  ACCOUNT_ALREADY_CONNECTED: "This account is already connected.",
  ACCOUNT_NOT_FOUND: "Connected account not found — reconnect in Settings.",
  ACCOUNT_INACTIVE: "This account is no longer active.",
  TOO_SOON: "Schedule must be at least 30 seconds in the future.",
  TOO_FAR: "Schedule must be within 1 year.",
  ALREADY_PUBLISHING: "Post is being published right now — wait a moment.",
  ALREADY_PUBLISHED: "Post already went out.",
  VISUAL_RENDER_FAILED: "Could not render the visual. Try again or pick a different template.",
  VISUAL_RENDER_QUOTA_EXCEEDED: "Visual rendering quota for this billing period has been used up. Try again later.",
  VISUAL_NOT_FOUND: "Visual not found.",
  VARIANT_NOT_FOUND: "Variant not found.",
  BROWSER_RENDERING_DISABLED: "Browser Rendering is not enabled on the Cloudflare account. Owner must enable it at dash.cloudflare.com → Workers & Pages → Browser Rendering.",
  PROJECT_BUSY: "This project is still generating. Wait a moment and try again.",
  INVALID_PLATFORM: "Unknown platform.",
  VERSION_LIMIT_REACHED: "Max 5 versions per platform. Delete one or use Replace mode.",
  CANNOT_DELETE_LAST_VERSION: "Can't delete the only version.",
};

export function apiErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const friendly = FRIENDLY_MESSAGES[err.code];
    const detail =
      typeof err.payload?.message === "string" && err.payload.message.length > 0
        ? ` (${err.payload.message})`
        : "";
    if (friendly) return friendly + detail;
    return `Something went wrong (${err.code})${detail}.`;
  }
  if (err instanceof Error) return err.message;
  return "Unknown error.";
}
